import { createSlice } from "@reduxjs/toolkit";

export const competitorSlice = createSlice({
  name: "competitor",
  initialState: { data: null },
  reducers: {
    setCompetitorAnalysis: (state, action) => {
      state.data = action.payload;
    },
  },
});
export const { setCompetitorAnalysis } = competitorSlice.actions;
